module.exports = __webpack_public_path__ + "static/img/animation33.gif";